(function($) {
  "use strict";

  require('es6-promise-promise');
  require('whatwg-fetch');

  $(document).ready(function() {

    let $aBlogs = [];
    $.each($('[data-blogid]'), function(index, value){
      $aBlogs.push(value.dataset.blogid) ;
    });

    $(".yltMtcShowModal").on("click", function() {
      var $questionnaireId = $(this).data("questionnaireid") ;
      var $testLanguage = $(this).data("language") ;
      var $url = HOME_URL+"api/questionnaire/" + $(this).data("questionnaireid") + '?include='+$(this).data("includemodules")+'&language='+$testLanguage;
      console.log($url) ;

      //$("#yltMtcModal").show().addClass('start');
      $("#yltMtcModal").addClass('active start');
      var $modalContent = $(".modal-content");

      $(".modal-footer button").hide();
      $("#yltMtcModal").find('.close').on('click', function() {
        $("#yltMtcModal").removeClass('active');
        window.setTimeout(function () {
          $("#yltMtcModal").removeClass('start')
        }, 300);
      });


      fetch($url)
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          let $blogId = $('.module').data('blogid') ;
          if($questionnaireId == 3){
            $blogId = 0 ;
          }

          let sDirectToModulesLable = 'Direct naar de module(s)' ;
          let sStartTestLable = 'Start de test' ;
          if($testLanguage == 'GB'){
            sDirectToModulesLable = 'Right away to the module(s)' ;
            sStartTestLable       = 'Start the test' ;
          }

          const $loginBtn =
              $('<button>')
                .addClass('btn btn-outline-secondary btnDirect')
                .html(sDirectToModulesLable)
                .on('click', () => window.location= sLandingspaginaUrl+'?o='+sOrganisationHash+'&b=0');

          var $introText = response.introText;
          var $knop = $(
            "<button class='btn btn-outline-primary'>"+sStartTestLable+"</button>"
          ).on("click", function() {
            $(this).remove();
            $loginBtn.remove();
            $('.btnDirect').remove() ;
            $("#yltMtcModal").removeClass('start');
            fetch($url)
              .then(checkStatus)
              .then(function(response){
                response.testLanguage = $testLanguage ;
                return response ;
              })
              .then(showQuestionnaire($("#yltMtcModal")))
              .catch(function(err) {
                //console.error('ERROR');
                console.error(err);
              });
          });


          $(".modal-body", $modalContent).html(" ");
          $(".modal-body", $modalContent).append(
            "<p style='margin-top:3rem;'>" + $introText + "</p>"
          );
          $(".modal-footer", $modalContent).append($knop);
          $(".modal-footer", $modalContent).append($loginBtn);
        });
    });

    if( window.location.hash == '#startzelftest'){
       $(".banner__content .yltMtcShowModal").trigger('click') ;
    } ;

    const checkStatus = require("./check-status.js");
    const showQuestionnaire = require("./show-questionnaire.js");
  });
})(jQuery);
